import React from "react";
import { Redirect } from "react-router-dom";
import { useAuth } from "./AuthContext";

const VerifiedRoute = ({ children }) => {
  const { isVerified, isLoading } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>; // or null/spinner
  }

  if (!isVerified) {
    return <Redirect to="/auth/verify-email" />;
  }

  return <>{children}</>;
};

export default VerifiedRoute;
